/**
 * Race a promise against a timeout.
 *
 * @template T
 * @param {Promise<T>} promise - The promise to time out.
 * @param {number} ms - Timeout in milliseconds.
 * @param {string} [label] - Optional label included in the timeout error message.
 * @returns {Promise<T>} A promise that resolves/rejects with the original promise, or rejects on timeout.
 */
export function withTimeout(promise, ms, label) {
  /** @type {ReturnType<typeof setTimeout> | undefined} */
  let timer;

  const timeoutPromise = new Promise((_, reject) => {
    timer = setTimeout(() => {
      const prefix = label ? `${label}` : 'Promise';
      reject(new Error(`${prefix} timed out after ${ms}ms`));
    }, ms);
  });

  return Promise.race([promise, timeoutPromise]).finally(() => {
    if (timer) clearTimeout(timer);
  });
}
